import { render, staticRenderFns } from "./select-upload-doc.vue?vue&type=template&id=784561fa&scoped=true&"
import script from "./select-upload-doc.vue?vue&type=script&lang=js&"
export * from "./select-upload-doc.vue?vue&type=script&lang=js&"
import style0 from "./select-upload-doc.vue?vue&type=style&index=0&id=784561fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784561fa",
  null
  
)

export default component.exports